<template>
  <el-table-column :prop="recursionInfo.prop" :label="recursionInfo.title">
    <template v-if="recursionInfo.children!==null">
      <recursion-table-column v-for="(info,index) of recursionInfo.children"
      :key="`col-${index}`" :recursionInfo="info"></recursion-table-column>
    </template>
  </el-table-column>
</template>
<script>

export default {
  name: 'recursion-table-column',
  props: {
    recursionInfo: {
      type: Object,
      default() {
        return {
          prop: '一级',
          title: '',
          children: '',
        };
      },
    },
  },
};
</script>
